import { Injectable } from '@angular/core';
import { SaveFormActionHandlerService } from './save.service';
import { FormDataService } from '../data.service';
import { FormShareService } from '../share.service';
import { FormStatusService } from '../status.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { EmailService } from '../../../email/services/email.service';
import { PublishSubscribeService } from '../../../fastlane-common/services/publish-subscribe.service';
import { formStatuses } from '../../form.constants';
import {EventContext} from '../../../fastlane-common/event/interfaces/event-context.interface';
import {FormStatusChange, InternalFormStatusChange} from '../../../fastlane-common/event/interfaces/form-status-event.interface';
import {events} from '../../../fastlane-common/event/event.constants';
import {ProjectFormWrapper} from '../../../project/models/project-form-wrapper.model';
import { AttachmentsService } from '../../../project/services/attachments.service';
import {NavService} from '../../../fastlane-common/services/nav.service';
import {SignaturesSendService} from '../../../management/signatures/send/send.service';
import { SaveCreditsFormActionHandlerService } from './save-credits.service';

@Injectable({
  providedIn: 'root'
})
export class SendIrrevocableDesigneeAgreementActionHandlerService extends SaveCreditsFormActionHandlerService {
  constructor(
    public attachmentService: AttachmentsService,
    formDataService: FormDataService,
    public formShareService: FormShareService,
    formStatusService: FormStatusService,
    public swalService: SwalService,
    userContextService: UserContextService,
    private agreementService: SignaturesSendService,
    emailService: EmailService,
    pubSubService: PublishSubscribeService,
    public navService: NavService
  ) {
    super(
      attachmentService,
      formDataService,
      formShareService,
      formStatusService,
      swalService,
      userContextService,
      emailService,
      pubSubService,
      navService
    );
  }
  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      super.exec().then(() => {
        that.swalService.load('Sending Irrevocable Designee Form...');
        this.agreementService.sendAgreement(this.formShareService.formId, 'IrrevocableDesignee').subscribe(res => {
          that.swalService.success({
            title: 'Irrevocable Designee Form Sent',
            text: 'Irrevocable Designee Form Sent'
          });
          that.formShareService.SetIrrevocableDesigneeLetterSent();
        }, err => {

        });
      });
    }).catch(() => {});
  }
}
